import { defineEntity, custom } from './_helpers.js';

export default defineEntity('internationalTransfer', {
    sscDeadlineReminder: custom({ scope: 'state' }),
    sscDeadlineOverdue: custom({ scope: 'state' }),
});
